import { Fragment, FunctionComponent } from 'react';
import { MultiLangInput } from '@starjack/shared-components';
import { Box, Divider, Stack, SvgIcon, Typography } from '@mui/material';
import { MultiLangString } from '@/models/general';
import { ProductTextReplacementDetail } from '@/models/textReplacement';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@heroicons/react/24/solid/TrashIcon';

type ChangeProductPersonNameProps = {
    productTextReplacements: ProductTextReplacementDetail[];
    onChange: (productTextReplacements: ProductTextReplacementDetail[]) => void;
};

export const ChangeProductPersonName: FunctionComponent<
    ChangeProductPersonNameProps
> = ({ productTextReplacements, onChange }) => {
    const handleChange = (
        index: number,
        key: 'newProductName' | 'newPersonTypeName',
        newValue: MultiLangString
    ) => {
        const copyReplacements = [...productTextReplacements];

        copyReplacements[index] = {
            ...copyReplacements[index],
            [key]: newValue,
        };

        onChange(copyReplacements);
    };

    return (
        <>
            {productTextReplacements.map((productPerson, index) => (
                <Fragment key={index}>
                    <Stack
                        sx={{
                            width: '100%',
                        }}
                        spacing={2}
                        direction='row'
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexGrow: 1,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 180,
                                }}
                            >
                                <Typography variant='subtitle2'>
                                    Ticketbezeichnung:
                                </Typography>
                                <Typography
                                    sx={{
                                        ml: 2,
                                        mt: 1,
                                    }}
                                >
                                    {productPerson.productName}
                                </Typography>
                            </Box>

                            <MultiLangInput
                                sx={{
                                    display: 'flex',
                                    flexGrow: 1,
                                    mx: 4,
                                }}
                                value={productPerson.newProductName}
                                label='Neue Ticketbezeichnung'
                                onBlur={(nextValue) => {
                                    handleChange(
                                        index,
                                        'newProductName',
                                        nextValue
                                    );
                                }}
                            />
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                flexGrow: 1,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 180,
                                }}
                            >
                                <Typography variant='subtitle2'>
                                    Personenbezeichnung:
                                </Typography>
                                <Typography
                                    sx={{
                                        ml: 2,
                                        mt: 1,
                                    }}
                                >
                                    {productPerson.personTypeName}
                                </Typography>
                            </Box>

                            <MultiLangInput
                                sx={{
                                    display: 'flex',
                                    flexGrow: 1,
                                    mx: 4,
                                }}
                                value={productPerson.newPersonTypeName}
                                label='Neue Personenbezeichnung'
                                onBlur={(nextValue) => {
                                    handleChange(
                                        index,
                                        'newPersonTypeName',
                                        nextValue
                                    );
                                }}
                            />
                        </Box>

                        <IconButton
                            aria-label='Löschen'
                            onClick={() => {
                                const copyReplacements = [
                                    ...productTextReplacements,
                                ];
                                copyReplacements.splice(index, 1);
                                onChange(copyReplacements);
                            }}
                        >
                            <SvgIcon>
                                <DeleteIcon />
                            </SvgIcon>
                        </IconButton>
                    </Stack>

                    {index !== productTextReplacements.length - 1 && (
                        <Divider
                            sx={{
                                my: 6,
                                width: '100%',
                            }}
                        />
                    )}
                </Fragment>
            ))}
        </>
    );
};
